import { select } from '@ngneat/elf';
import { selectAllEntities } from '@ngneat/elf-entities';
import { createRequestDataSource } from '@ngneat/elf-requests';
import { auditOfferStore } from './audit-offer.store';

export const getAuditOfferDataSource = createRequestDataSource({
  store: auditOfferStore,
  data$: () => auditOfferStore.pipe(selectAllEntities()),
  requestKey: 'getAuditOffer',
  dataKey: 'auditsOffer',
});

export const getAuditOffersDataSource = createRequestDataSource({
  store: auditOfferStore,
  data$: () => auditOfferStore.pipe(select((state) => state.auditOffers)),
  requestKey: 'GETAuditOffersByAudit',
  dataKey: 'auditsOffers',
});

export const getEngagedSupplierDataSource = createRequestDataSource({
  store: auditOfferStore,
  data$: () => auditOfferStore.pipe(select((state) => state.engagedSuppliers)),
  requestKey: 'GETEngagedSupplierByAudit',
  dataKey: 'engagedSuppliers',
});